import React from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';

const InspectionSuccessPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { inspectionId, totalItems, status } = location.state || {};

  const isPending = status === 'PENDING_APPROVAL';

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="text-6xl mb-4">
          {isPending ? '⏳' : '✅'}
        </div>
        <h1 className="text-2xl font-bold text-gray-800 mb-2">
          {isPending ? 'ส่งผลการตรวจสอบสำเร็จ' : 'บันทึกสำเร็จ'}
        </h1>
        <div className="text-4xl mb-4">🎉</div>
        <h2 className="text-xl font-semibold text-gray-800 mb-6">
          {isPending ? 'รอการอนุมัติจากหัวหน้าทีม' : 'การตรวจสอบเสร็จสมบูรณ์'}
        </h2>

        <div className="bg-gray-50 rounded-lg p-6 mb-6 text-left">
          <h3 className="font-semibold text-gray-800 mb-3">📊 สรุป:</h3>
          <ul className="space-y-2 text-sm text-gray-700">
            <li>• ตรวจสอบ: {totalItems || 0} รายการ</li>
            <li>• สถานะ: {isPending ? '⏳ รออนุมัติ' : '✅ เรียบร้อย'}</li>
          </ul>
        </div>

        {isPending ? (
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
            <p className="text-sm text-gray-700">
              📤 ผลการตรวจสอบถูกส่งไปยังหัวหน้าทีมแล้ว<br />
              คุณจะได้รับการแจ้งเตือนเมื่อมีการอนุมัติหรือไม่อนุมัติ
            </p>
          </div>
        ) : (
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <p className="text-sm text-gray-700">
              📤 ส่งต่อเวรถัดไปแล้ว
            </p>
          </div>
        )}

        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
          <p className="text-sm text-gray-700">
            💡 <strong>เคล็ดลับ:</strong> คุณได้รับ 15 Points และ 25 XP สำหรับการตรวจสอบอุปกรณ์
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {isPending && inspectionId && (
            <Link
              to={`/nurse/equipment/inspection/${inspectionId}`}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-center font-medium"
            >
              ดูรายละเอียด
            </Link>
          )}
          <Link
            to="/nurse/equipment/my-inspections"
            className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 text-center font-medium"
          >
            ดูรายการตรวจสอบของฉัน
          </Link>
          <div className="flex gap-3">
            <button
              onClick={() => navigate('/nurse/equipment/inspection')}
              className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
            >
              ตรวจสอบอีกครั้ง
            </button>
            <button
              onClick={() => navigate('/nurse/equipment')}
              className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              กลับหน้าหลัก
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InspectionSuccessPage;

